import React from 'react';

import {
  Card,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';
import {generateTestId} from '@spaced-out/ui-design-system/lib/utils/qa';
import css from './card-children.css';


export const CardChildren = ({
  children,
  testId,
}: {
  children: React.ReactNode;
  testId?: string;
}) => {
  return (
    <Card
      classNames={{wrapper: css.cardChildren}}
      testId={generateTestId({base: testId, slot: 'card-children'})}
    >
      <CardContent
        testId={generateTestId({base: testId, slot: 'card-children-content'})}
      >
        {/* Children are react components */}
        {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
        {children}
      </CardContent>
    </Card>
  );
};
